import {useConnect} from '@lore/query-connect';

const CACHE_TTL = 4 * 60 * 60 * 1000; // 4 hours - tags trees have not changed in 2 years

export default function useTagTrees(props = {}) {
  return useConnect('tagTree.find', {
    pagination: {
      pageSize: 1000
    },
  }, {cacheTime: CACHE_TTL * 2, staleTime: CACHE_TTL, refetchOnWindowFocus: false});
}
